import React from 'react';
import { string, shape, number, func } from 'prop-types';
import { getHumanisedNumber } from '@paddl/utils-js';
import { ProfileHeroWrapper, MainContent, ActivitiesOverview, TextContent, TotalXp, FullName, ProfileTitle, Location, ProfileAvatarWrapper, ProfileInfoWrapper, ProfileInfoDataPoint, ProfileInfoDataType } from './ProfileHero.styles';
import { Avatar, Icons, InnerContentWrapper, useWidth } from '../..';
export const ProfileHero = _ref => {
  let {
    profileDetails: {
      fullName,
      profileTitle,
      location,
      avatarUrl
    },
    profileStats: {
      totalXp,
      totalActivities,
      totalSkills
    },
    headlineElements: {
      fullName: fullNameElement,
      profileTitle: profileTitleElement,
      location: locationElement,
      profileStats: profileStatsElement
    },
    backgroundImage,
    onClick
  } = _ref;
  const PhotoIcon = Icons.photo;
  const width = useWidth();
  return /*#__PURE__*/React.createElement(ProfileHeroWrapper, {
    backgroundImage: backgroundImage,
    width: width
  }, /*#__PURE__*/React.createElement(InnerContentWrapper, {
    style: {
      color: 'white',
      width: '-webkit-fill-available'
    }
  }, /*#__PURE__*/React.createElement(MainContent, {
    width: width
  }, avatarUrl && /*#__PURE__*/React.createElement(ProfileAvatarWrapper, {
    "data-test-id": "profile-avatar-wrapper",
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Avatar, {
    imageUrl: avatarUrl,
    imageAlt: fullName,
    size: "medium-large",
    hasBorder: true
  }), onClick && /*#__PURE__*/React.createElement(PhotoIcon, null)), /*#__PURE__*/React.createElement(TextContent, {
    width: width,
    avatarUrl: avatarUrl
  }, /*#__PURE__*/React.createElement(FullName, {
    as: fullNameElement,
    width: width
  }, fullName), profileTitle && /*#__PURE__*/React.createElement(ProfileTitle, {
    as: profileTitleElement,
    width: width
  }, profileTitle), location && /*#__PURE__*/React.createElement(Location, {
    as: locationElement,
    width: width
  }, location))), /*#__PURE__*/React.createElement(ActivitiesOverview, {
    width: width
  }, /*#__PURE__*/React.createElement(TotalXp, {
    as: profileStatsElement
  }, /*#__PURE__*/React.createElement(ProfileInfoDataPoint, null, getHumanisedNumber(totalXp)), /*#__PURE__*/React.createElement("small", null, "XP")), /*#__PURE__*/React.createElement(ProfileInfoWrapper, {
    as: profileStatsElement
  }, /*#__PURE__*/React.createElement(ProfileInfoDataPoint, null, totalActivities), /*#__PURE__*/React.createElement(ProfileInfoDataType, null, "activities")), /*#__PURE__*/React.createElement(ProfileInfoWrapper, {
    as: profileStatsElement
  }, /*#__PURE__*/React.createElement(ProfileInfoDataPoint, null, totalSkills), /*#__PURE__*/React.createElement(ProfileInfoDataType, null, "skills")))));
};
ProfileHero.propTypes = {
  profileDetails: shape({
    fullName: string.isRequired,
    profileTitle: string,
    location: string,
    avatarUrl: string
  }),
  headlineElements: shape({
    fullName: string,
    profileTitle: string,
    location: string
  }),
  profileStats: shape({
    totalXp: number,
    totalActivities: number,
    totalSkills: number
  }),
  backgroundImage: string.isRequired,
  onClick: func
};
ProfileHero.defaultProps = {
  profileDetails: {
    profileTitle: null,
    location: null,
    avatarUrl: null
  },
  profileStats: {
    totalXp: 0,
    totalActivities: 0,
    totalSkills: 0
  },
  headlineElements: {
    fullName: 'h1',
    profileTitle: 'h2',
    location: 'h2',
    profileStats: 'span'
  },
  onClick: null
};